import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["assetType"];
import { LANDING_PAGES_URL, WEB_INTERACTIVES_URL } from 'personalization-lib/constants/urls';
import { ASSET_TYPES } from 'personalization-lib/constants/assetTypes';
import { fetchContentByIds } from './contentApiClient';
import { fetchLandingPage, fetchLandingPagesOptions } from './assetTypes/landingPagesApiClient';
import { fetchWebInteractive, fetchWebInteractivesOptions } from './assetTypes/webInteractivesApiClient';
export const fetchAssetById = asset => {
  switch (asset.source) {
    case ASSET_TYPES.WEB_INTERACTIVE:
      return fetchWebInteractive(asset.id);
    case ASSET_TYPES.LANDING_PAGE:
      return fetchLandingPage(asset.id);
    default:
      throw new Error(`Unknown asset type: ${String(asset.source)}`);
  }
};
export const fetchAssetsByIds = ({
  source,
  ids
}) => {
  switch (source) {
    case ASSET_TYPES.WEB_INTERACTIVE:
      return fetchContentByIds({
        url: WEB_INTERACTIVES_URL,
        ids
      });
    case ASSET_TYPES.LANDING_PAGE:
      return fetchContentByIds({
        url: LANDING_PAGES_URL,
        ids
      });
    default:
      console.error(`Unknown asset type: ${source.toString()}`);
      return Promise.resolve([]);
  }
};
export const fetchAssetOptions = _ref => {
  let {
      assetType
    } = _ref,
    pagination = _objectWithoutPropertiesLoose(_ref, _excluded);
  switch (assetType) {
    case ASSET_TYPES.WEB_INTERACTIVE:
      return fetchWebInteractivesOptions(pagination);
    case ASSET_TYPES.LANDING_PAGE:
      return fetchLandingPagesOptions(pagination);
    default:
      console.error(`Unknown asset type: ${assetType}`);
      return Promise.resolve({
        results: [],
        offset: 0,
        total: 0
      });
  }
};